// ftp://ftp.hp.com/pub/networking/software/9408sl-9300m-CLI-Jun2005-59906031-Chap11.pdf

/*
Cisco
  <0-255>                      ICMP message type
  administratively-prohibited  Administratively prohibited
  alternate-address            Alternate address
  conversion-error             Datagram conversion
  dod-host-prohibited        Host prohibited
  dod-net-prohibited           Net prohibited
  echo                         Echo (ping)
  echo-reply                   Echo reply
  general-parameter-problem    Parameter problem
  host-isolated                Host isolated
  host-precedence-unreachable  Host unreachable for precedence
  host-redirect                Host redirect
  host-tos-redirect            Host redirect for TOS
  host-tos-unreachable         Host unreachable for TOS
  host-unknown                 Host unknown
  host-unreachable             Host unreachable
  information-reply            Information replies
  information-request          Information requests
  mask-reply                   Mask replies
  mask-request                 Mask requests
  mobile-redirect              Mobile host redirect
  net-redirect                 Network redirect
  net-tos-redirect             Net redirect for TOS
  net-tos-unreachable          Network unreachable for TOS
  net-unreachable              Net unreachable
  network-unknown              Network unknown
  no-room-for-option           Parameter required but no room
  option-missing               Parameter required but not present
  packet-too-big               Fragmentation needed and DF set
  parameter-problem            All parameter problems
  port-unreachable             Port unreachable
  precedence-unreachable       Precedence cutoff
  protocol-unreachable         Protocol unreachable
  reassembly-timeout           Reassembly timeout
  redirect                     All redirects
  router-advertisement         Router discovery advertisements
  router-solicitation          Router discovery solicitations
  source-quench                Source quenches
  source-route-failed          Source route failed
  time-exceeded                All time exceededs
  timestamp-reply              Timestamp replies
  timestamp-request            Timestamp requests
  traceroute                   Traceroute
  ttl-exceeded                 TTL exceeded
  unreachable                  All unreachables

Cisco ACI/APIC - https://pubhub.devnetcloud.com/media/apic-mim-ref-301/docs/TYPE-icmpv4-Type.html
  echo-rep 0 Echo Reply
  dst-unreach 3 Destination Unreachable
  src-quench 4 Source Quench
  echo 8 Echo
  time-exceeded 11 Time Exceeded

HP

  echo                  Type=8, Code=0
  echo-reply            Type=0, Code=0
  fragmentneed-DFset    Type=3, Code=4
  host-redirect         Type=5, Code=1
  host-tos-redirect     Type=5, Code=3
  host-unreachable      Type=3, Code=1
  information-reply     Type=16, Code=0
  information-request   Type=15, Code=0
  net-redirect          Type=5, Code=0
  net-tos-redirect      Type=5, Code=2
  net-unreachable       Type=3, Code=0
  parameter-problem     Type=12, Code=0
  port-unreachable      Type=3, Code=3
  protocol-unreachable  Type=3, Code=2
  reassembly-timeout    Type=11, Code=1
  source-quench         Type=4, Code=0
  source-route-failed   Type=3, Code=5
  timestamp-reply       Type=14, Code=0
  timestamp-request     Type=13, Code=0
  ttl-exceeded          Type=11, Code=0
*/

export type IcmpTypesCode = {
  type: number;
  code: number;
  name: string;
  keys: string[];
};

export function icmpTypesCodes(): IcmpTypesCode[] {
  return [
    { type: 0, code: 0, name: 'Echo reply', keys: ['echo-reply', 'echo-rep'] },
    {
      type: 3,
      code: 0,
      name: 'Net Unreachable',
      keys: ['net-unreachable', 'network-unreachable', 'dst-unreach'],
    },
    { type: 3, code: 1, name: 'Host Unreachable', keys: ['host-unreachable'] },
    {
      type: 3,
      code: 2,
      name: 'Protocol Unreachable',
      keys: ['protocol-unreachable'],
    },
    { type: 3, code: 3, name: 'Port Unreachable', keys: ['port-unreachable'] },
    {
      type: 3,
      code: 4,
      name: 'Fragmentation Needed',
      keys: ['packet-too-big', 'fragmentneed-dfset', 'fragmentation-needed'],
    },
    {
      type: 3,
      code: 5,
      name: 'Source Route Failed',
      keys: ['source-route-failed'],
    },
    {
      type: 3,
      code: 6,
      name: 'Destination Network Unknown',
      keys: ['destination-network-unknown', 'network-unknown'],
    },
    {
      type: 3,
      code: 7,
      name: 'Destination Host Unknown',
      keys: ['destination-host-unknown', 'host-unknown'],
    },
    {
      type: 3,
      code: 8,
      name: 'Source Host Isolated',
      keys: ['source-host-isolated', 'host-isolated'],
    },
    {
      type: 3,
      code: 9,
      name: 'Destination Network Admin Prohibited',
      keys: [
        'destination-net-prohibited',
        'destination-network-prohibited',
        'dod-net-prohibited',
      ],
    },
    {
      type: 3,
      code: 10,
      name: 'Destination Host Admin Prohibited',
      keys: ['destination-host-prohibited', 'dod-host-prohibited'],
    },
    {
      type: 3,
      code: 11,
      name: 'Destination Network Unreachable for ToS',
      keys: ['net-tos-unreachable', 'network-unreachable-for-tos'],
    },
    {
      type: 3,
      code: 12,
      name: 'Destination Host Unreachable for ToS',
      keys: ['host-tos-unreachable', 'host-unreachable-for-tos'],
    },
    {
      type: 3,
      code: 13,
      name: 'Communication Administratively Prohibited',
      keys: [
        'administratively-prohibited',
        'communication-prohibited-by-filtering',
      ],
    },
    {
      type: 3,
      code: 14,
      name: 'Host Precedence Violation',
      keys: ['host-precedence-violation', 'host-precedence-unreachable'],
    },
    {
      type: 3,
      code: 15,
      name: 'Precedence cutoff in effect',
      keys: [
        'precedence-cutoff',
        'precedence-unreachable',
        'precedence-cutoff-in-effect',
      ],
    },
    {
      type: 4,
      code: 0,
      name: 'Source quench',
      keys: ['source-quench', 'src-quench'],
    },
    {
      type: 5,
      code: 0,
      name: 'Redirect Datagram for the Network',
      keys: ['net-redirect', 'redirect-for-network'],
    },
    {
      type: 5,
      code: 1,
      name: 'Redirect Datagram for the Host',
      keys: ['host-redirect', 'redirect-for-host'],
    },
    {
      type: 5,
      code: 2,
      name: 'Redirect Datagram for the ToS and Network',
      keys: ['net-tos-redirect', 'redirect-for-tos-and-net'],
    },
    {
      type: 5,
      code: 3,
      name: 'Redirect Datagram for the ToS and Host',
      keys: ['host-tos-redirect', 'redirect-for-tos-and-host'],
    },
    {
      type: 6,
      code: 0,
      name: 'Alternate Address for Host',
      keys: ['alternate-address'],
    },
    { type: 8, code: 0, name: 'Echo request', keys: ['echo', 'echo-request'] },
    {
      type: 9,
      code: 0,
      name: 'Normal router advertisement',
      keys: ['router-advertisement'],
    },
    { type: 9, code: 16, name: 'Does not route common traffic', keys: [] },
    {
      type: 10,
      code: 0,
      name: 'Router solicitation',
      keys: ['router-solicitation'],
    },
    {
      type: 11,
      code: 0,
      name: 'Time to Live exceeded in Transit',
      keys: ['time-exceeded', 'ttl-exceeded', 'ttl-eq-zero-during-transit'],
    },
    {
      type: 11,
      code: 1,
      name: 'Fragment Reassembly Time Exceeded',
      keys: ['reassembly-timeout', 'ttl-eq-zero-during-reassembly'],
    },
    {
      type: 12,
      code: 0,
      name: 'Pointer indicates the error',
      keys: ['parameter-problem', 'ip-header-bad'],
    },
    {
      type: 12,
      code: 1,
      name: 'Missing a Required Option',
      keys: [
        'general-parameter-problem',
        'required-option-missing',
        'option-missing',
      ],
    },
    { type: 12, code: 2, name: 'Bad Length', keys: ['no-room-for-option'] },
    {
      type: 13,
      code: 0,
      name: 'Timestamp request',
      keys: ['timestamp-request'],
    },
    { type: 14, code: 0, name: 'Timestamp reply', keys: ['timestamp-reply'] },
    {
      type: 15,
      code: 0,
      name: 'Information request',
      keys: ['information-request'],
    },
    {
      type: 16,
      code: 0,
      name: 'Information reply',
      keys: ['information-reply'],
    },
    { type: 17, code: 0, name: 'Mask request', keys: ['mask-request'] },
    { type: 18, code: 0, name: 'Mask reply', keys: ['mask-reply'] },
    { type: 40, code: 0, name: 'Bad SPI', keys: [] },
    { type: 40, code: 1, name: 'Authentication Failed', keys: [] },
    { type: 40, code: 2, name: 'Decompression Failed', keys: [] },
    { type: 40, code: 3, name: 'Decryption Failed', keys: [] },
    { type: 40, code: 4, name: 'Need Authentication', keys: [] },
    { type: 40, code: 5, name: 'Need Authorization', keys: [] },
  ];
}
